import ConfidenceMessaging from './ConfidenceMessaging';

export default ConfidenceMessaging;
